<template>
	<div class="columns is-multiline">
		<div class="column is-full mr-1">
			<review-summary
				@toggle-review-input="toggleReviewInput"
				:summary_prop="summary"></review-summary>
		</div>
		<div
			v-show="enableReviewInput"
			class="column is-full p-0 height-box">
			<review-input
				ref="reviewInput"
				@update-review-section="$parent.updateReviewSection()"
				transition="expand"
				:review_link_prop="review_link_prop"
				:product_id_prop="product_id_prop"
				:placeholder_prop="placeholder_prop"
				@expand-review-section="enableReviewInput = !enableReviewInput"
				:mode_prop="mode"></review-input>
		</div>
	</div>
</template>
<style scoped>
	/* always present */
	.expand-transition {
		transition: all 2s ease;
		height: 0;
		opacity: 100%;
	}
	/* .expand-enter defines the starting state for entering */
	/* .expand-leave defines the ending state for leaving */
	.expand-enter {
		height: 0;
		opacity: 0;
	}

	.expand-leave {
		height: 100%;
		opacity: 100%;
	}
</style>
<script>
	import axios from "axios";
	axios.defaults.headers.post["X-CSRF-TOKEN"] = window.csrf_token;

	import ReviewInput from "./ReviewInput.vue";
	import ReviewSummary from "./ReviewSummary.vue";

	export default {
		props: {
			placeholder_prop: String,
			review_link_prop: String,
			product_id_prop: Number,
			summary_prop: Object,
			mode_prop: String,
		},
		emits: ["update-review-section"],
		components: { ReviewInput, ReviewSummary },
		data() {
			return {
				enableReviewInput: false,
			};
		},
		computed: {
			placeholder() {
				return this.$props.placeholder_prop
					? this.$props.placeholder_prop
					: "";
			},
			mode() {
				switch (this.mode_prop) {
					case "edit":
						return "edit";
						break;
				}
				return "add";
			},
			summary() {
				if (typeof this.$props.summary_prop != "undefined") {
					return this.$props.summary_prop;
				}
				return {};
			},
		},
		methods: {
			toggleReviewInput() {
				this.enableReviewInput = !this.enableReviewInput;
			},
		},
	};
</script>
